const AVATAR_PALETTE: { bg: string; color: string }[] = [
    {bg: '#E0F2F1', color: '#00695C'},
    {bg: '#E3F2FD', color: '#1565C0'},
    {bg: '#FFF3E0', color: '#E65100'},
    {bg: '#F3E5F5', color: '#6A1B9A'},
    {bg: '#E8F5E9', color: '#2E7D32'},
    {bg: '#FCE4EC', color: '#AD1457'},
];

export function getInitials(firstName?: string, lastName?: string): string {
    const first = (firstName ?? '').trim().charAt(0);
    const last = (lastName ?? '').trim().charAt(0);
    return `${first}${last}`.toUpperCase() || '?';
}

export function getAvatarColors(seed: string): { bg: string; color: string } {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
}
